import http from '../../../Utils/http';
const GetAllDsoDisplays = {
  name: 'allDsodisplays',
  state: {
    data: [],

    loading: false,
    error: '',
    rpp: 10,
    totalCount: 0,
  },
  reducers: {
    getAllDsoDisplaysReceived(state, payload) {
      return {
        ...state,
        data: payload.data,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },
  },
  effects: (dispatch) => ({
    async getDsoDisplays({ page, size, org_id }) {
      // const id = JSON.parse(localStorage.getItem('userInfo')).org_id;
      // let url = `savvy/displays/displays-frames-and-zones-number/${id}`;
      // const response = await http.get(`${url}`);
      // this.getAllDsoDisplaysReceived({
      //   data: response.data.data,
      // });
    },
    async getDisplayByID(id) {
      let url = `savvy/displays/displays-frames-and-zones-number-by-display-id/${id}`;
      const response = await http.get(`${url}`);

      this.getAllDsoDisplaysReceived({
        data: response.data.data,
      });
    },
    // async getDsoDisplaysWithZones({ page, size, org_id }) {
    //   const id = JSON.parse(localStorage.getItem('userInfo')).org_id;

    //   let url = `savvy/displays/${id}?page=${page}&size=${size}`;
    //   const response = await http.get(`${url}`);

    // },
  }),
};

export default GetAllDsoDisplays;
